import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  message,
  DatePicker,
  Select,
  Typography,
  Divider,
  Checkbox,
} from "antd";
import { Context } from "../context/store";
import ACTIONS from "../context/actions";
import { logoutUser } from "../helpers/authHelper";
import { baseAPIUrl } from "../constants/urlConstants";
import { LotCreator } from "./LotCreator";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

export const SourceMedReceiver = (props) => {
  const [form] = Form.useForm();
  const [state, dispatch] = useContext(Context);
  const [submitting, setSubmitting] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [products, setProducts] = useState([]);
  const [qcExplanationDisabled, setQcExplanationDisabled] = useState(false);

  //get products and source meds in order to suggest them
  useEffect(() => {
    //when loading ensure page is set

    //get vendors
    fetch(baseAPIUrl + "vendors", {
      headers: { user_key: state.key },
    })
      .then((res) => {
        //check if need to login again
        if (res.status === 401) {
          message.info("Please Login Again!");
          logoutUser();
          dispatch({ type: ACTIONS.CLEAR_USER_DETAILS });
          return false;
        }
        return res.json();
      })
      .then(
        (results) => {
          setVendors(results);
        },
        (error) => {
          console.log(error);
        },
      );

    //get products
    fetch(baseAPIUrl + "sourceproducts", {
      headers: { user_key: state.key },
    })
      .then((res) => {
        //check if need to login again
        if (res.status === 401) {
          message.info("Please Login Again!");
          logoutUser();
          dispatch({ type: ACTIONS.CLEAR_USER_DETAILS });
          return false;
        }
        return res.json();
      })
      .then(
        (results) => {
          setProducts(results);
        },
        (error) => {
          console.log(error);
        },
      );

    dispatch({
      type: ACTIONS.SET_CURRENT_PAGE,
      payload: { page: "receiveSourceMed" },
    });
  }, []);

  const onVendorChange = (value) => {
    const selectedVendor = vendors.find((vendor) => {
      return vendor.id === value;
    });

    console.log(selectedVendor);
    form.setFieldsValue({
      mel: selectedVendor.license_number,
    });
  };

  const onProductChange = (value) => {
    const selectedProduct = products.find((product) => {
      return product.id === value;
    });

    console.log(selectedProduct);
    form.setFieldsValue({
      dominance: selectedProduct.dominance,
      material: selectedProduct.material,
    });
  };

  const onQCCheckChange = (value) => {
    const isQC =
      form.getFieldValue("dispocheck") &&
      form.getFieldValue("visualcheck") &&
      form.getFieldValue("papercheck");
    setQcExplanationDisabled(isQC);
    if (isQC) {
      form.setFieldValue("qc_text", "N/A");
    }
  };

  //handles sending data from form to DB
  const onSubmitSourceMed = (values) => {
    console.log("submitting source med");
    if(!values.date_received){
      values.date_received=moment()
    }
    console.log(values);
    setSubmitting(true);
    fetch(baseAPIUrl + "sourcemeds/receive", {
      method: "POST",
      body: JSON.stringify({
        ...values,
      }),
      headers: {
        "Content-Type": "application/json",
        user_key: state.key,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then(
        (results) => {
          setSubmitting(false);
          if (results.success) {
            form.resetFields();
            message.success(results.message);
          } else {
            message.error(results.message);
          }
        },
        (error) => {
          setSubmitting(false);
          message.error("Failed to create the source med");
          console.log(error);
        },
      );
  };

  const generateProductName = () => {
    const dominance = form.getFieldValue("dominance");
    const material = form.getFieldValue("material");
    return `${dominance} ${material}`;
  };

  return (
    <div className="creator-content">
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        layout="horizontal"
        name="source_med_receiver"
        className="source_med-receiver"
        initialValues={{ remember: true }}
        scrollToFirstError
        form={form}
        onFinish={onSubmitSourceMed}
      >
        <Title level={2}>Receive Source Material</Title>
        <Divider />
        <Form.Item
          label="Source Material Product"
          name="product"
          rules={[
            {
              message: "Source requires a name!",
              required: true,
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Product to Receive"
            optionFilterProp="children"
            onChange={onProductChange}
          >
            {products.map((product, i) => (
              <Option value={product.id} key={i}>{`${product.name}`}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Material"
          name="material"
          rules={[
            {
              message: "Must select a type of material!",
              required: true,
            },
          ]}
        >
          <Input disabled placeholder="Material"></Input>
          {/* <Select showSearch placeholder="Material" onChange={onMaterialChange}>
            <Option value="Crude">Crude</Option>
            <Option value="Trim">Trim</Option>
            <Option value="Distillate">Distillate</Option>
            <Option value="Hybrid">Hybrid</Option>
          </Select> */}
        </Form.Item>
        <Form.Item
          label="Dominance"
          name="dominance"
          rules={[
            {
              message: "Must select a dominance!",
              required: true,
            },
          ]}
        >
          <Input disabled placeholder="Dominance"></Input>
          {/* <Select
            showSearch
            placeholder="Dominance"
            onChange={onDominanceChange}
          >
            <Option value="Indica Blend">Indica Blend</Option>
            <Option value="Sativa Blend">Sativa Blend</Option>
            <Option value="Balanced THC:CBD Blend">
              Balanced THC:CBD Blend
            </Option>
            <Option value="Hemp CBD Blend">Hemp CBD Blend</Option>
            <Option value="Hybrid Blend">Hybrid Blend</Option>
          </Select> */}
        </Form.Item>
        {/* <Form.Item
          label="Vendor Name"
          name="vendor"
          rules={[
            {
              message: "Source requires a vendor!",
              required: true,
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Vendor"
            optionFilterProp="children"
            onChange={onVendorChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {vendors.map((vendor, i) => (
              <Option
                value={vendor.id}
                key={i}
              >{`${vendor.vendor_name}(${vendor.partner_name})`}</Option>
            ))}
          </Select>
        </Form.Item> */}
        <Form.Item
          label="Batch ID"
          name="batch_id"
          rules={[
            {
              message: "A batchid must be given to a source med!",
              required: true,
            },
          ]}
        >
          <Input maxLength={100} placeholder="Batch ID" />
        </Form.Item>
        {/* <Form.Item
          label="Package ID"
          name="package_id"
          rules={[
            {
              message: "A batchid must be given to a source med!",
              required: true,
            },
          ]}
        >
          <Input maxLength={100} placeholder="Batch ID" />
        </Form.Item> */}
        <LotCreator batchID={form.getFieldValue("batch_id")} />
        <Form.Item label="Received Date" name="date_received">
          <DatePicker
            format="MM/DD/YYYY"
            defaultValue={moment()}
            //disable selecting a day before today
          />
        </Form.Item>
        <Form.Item
          label="Manufactured Date"
          name="manufacturing_date"
          rules={[
            {
              message: "Must enter a manufactured date",
              required: true,
            },
          ]}
        >
          <DatePicker format="MM/DD/YYYY" />
        </Form.Item>
        <Form.Item
          //Sale Date
          label="Sale Date"
          name="sale_date"
          rules={[
            {
              message: "Must enter a sale date",
              required: true,
            },
          ]}
        >
          <DatePicker format="MM/DD/YYYY" />
        </Form.Item>
        <Form.Item
          label="PO Number"
          name="po_number"
          rules={[
            {
              message: "Must enter the purchasing airtable PO number",
              required: true,
            },
          ]}
          //Airtable PO Number
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          label="Extraction Method"
          name="extraction_method"
          rules={[
            {
              message: "An extraction method must be given to a source!",
              required: true,
            },
          ]}
        >
          <Select showSearch placeholder="Extraction Method">
            <Option value="Ethanol">Ethanol</Option>
            <Option value="Butane">Butane</Option>
            <Option value="Veg. Oil">Veg. Oil</Option>
            <Option value="BHO">BHO</Option>
          </Select>
        </Form.Item>

        <Form.Item
          //Paperwork checkbox
          label="Paperwork correct?"
          name="papercheck"
          valuePropName="checked"
        >
          <Checkbox onChange={onQCCheckChange} />
        </Form.Item>

        <Form.Item
          //Disposition checkbox
          label="Disposition correct?"
          name="dispocheck"
          valuePropName="checked"
        >
          <Checkbox onChange={onQCCheckChange} />
        </Form.Item>

        <Form.Item
          //Visual inspection checkbox
          label="Visual inspection passed?"
          name="visualcheck"
          valuePropName="checked"
        >
          <Checkbox onChange={onQCCheckChange} />
        </Form.Item>

        <Form.Item
          label="QC Nonconformance Explanation"
          name="qc_text"
          hidden={qcExplanationDisabled}
          rules={[
            {
              message: "Please explain the nonconformance.",
              required: !qcExplanationDisabled,
            },
          ]}
        >
          <Input disabled={qcExplanationDisabled} />
        </Form.Item>
        <Form.Item
          label="Notes"
          name="comments"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input size="large"></Input>
        </Form.Item>
        <Form.Item
          //Receiver name/signoff
          label="Signature"
          name="signature"
          rules={[
            {
              message: "Please enter your name.",
              required: true,
            },
          ]}
        >
          <Input maxLength={100} placeholder="Signature" />
        </Form.Item>

        <Form.Item label=" " colon={false}>
          <Button
            type="primary"
            htmlType="submit"
            className="submit-ticket-button"
            loading={submitting}
            //TODO: A bunch of validation and sending info to API
            //Put fields into DB
            //Create MJP PO or Airtable lot entry
          >
            Submit Ticket
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
